const { registerBlockType } = window.wp.blocks;

const { 
    RichText,
    InspectorControls,
    ColorPalette,
    MediaUpload,
    InnerBlocks
} = window.wp.editor;

const { 
    PanelBody, 
    IconButton, 
    RangeControl, 
    TextControl
} = window.wp.components;

const ALLOWED_BLOCKS = ['core/button'];

if ( window.wp.ajax ) {
    registerBlockType('custom-gutenberg/card-destination', {
        // built-in attributes
        title: 'Card Destination',
        description: 'Custom Destination Card',
        icon: 'admin-page',
        category: 'custom-components',
        example: {},

        // custom attributes
        attributes: {
            link: {
                type: 'string',
                default: '',
            },
            backgroundImage: {
                type: 'string',
                default: '/wp-content/uploads/m14-011-00015-16866.jpg'
            }, 
            title: {
                type: 'string',
                default: ''
            },
            description: {
                type: 'string',
                default: ''
            },
            viewMore: {
                type: 'string',
                default: ''
            },
        },

        // built-in functions
        edit({ attributes, setAttributes }) {

            const {
                link,
                backgroundImage,
                title,
                description,
                viewMore
            } = attributes;

            // custom functions
            function onLinkChange (link) {
                setAttributes({link: link});
            };

            function onSelectImage (image) {
                setAttributes({backgroundImage: image.sizes.full.url});
            }

            function onTitleChange(title) {
                setAttributes({title: title});
            }

            function onDescriptionChange(description) {
                setAttributes({description: description});
            }

            function onViewMoreChange(viewMore) {
                setAttributes({viewMore: viewMore});
            }

            return ([
                <InspectorControls style={ { marginBottom: '40px' } }>
                    <PanelBody title={ 'Link' }>
                        <p><strong>Enter url: (ex: /hr/atlantis-premium)</strong></p>
                        <TextControl value={ link } onChange={ onLinkChange }></TextControl>
                    </PanelBody>
                    <PanelBody title={ 'Background Image Settings' }>
                        <MediaUpload 
                            onSelect={ onSelectImage }
                            type="image"
                            value={ backgroundImage } 
                            render={ ( { open } ) => (
                                <IconButton
                                    onClick={ open }
                                    icon="upload"
                                    classNames="editor-media-placeholder__button is-button is-default is-large">
                                    Select Background Image
                                </IconButton>
                            ) } />
                    </PanelBody>
                </InspectorControls>
                ,
                <a >
                    <div class="cover-image bg-dark text-white rounded shadow position-relative" style={{ height: 300, backgroundImage: `url(${backgroundImage})` }} >
                        <div class="p-4 position-absolute" style={{ bottom: 0, left: 0, right: 0 }} >
                            <RichText 
                                key="editable" 
                                tagName="h3" 
                                class="mb-3"
                                placeholder="Service Title" 
                                value={ title }
                                onChange={ onTitleChange }
                                style={ { color: '#fff' } } />
                            <RichText 
                                key="editable" 
                                tagName="p" 
                                class="small"
                                placeholder="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nec ornare sapien eu est sociis phasellus hendrerit quam semper." 
                                value={ description }
                                onChange={ onDescriptionChange }
                                style={ { color: '#fff' } } />
                            <RichText 
                                key="editable" 
                                tagName="div" 
                                class="text-warning font-weight-bolder"
                                placeholder="Learn more" 
                                value={ viewMore }
                                onChange={ onViewMoreChange } />
                        </div>
                    </div>
                </a>
            ]
            );
        },

        save({ attributes }) {

            const {
                link,
                backgroundImage,
                title,
                description,
                viewMore
            } = attributes;

            return (
                <a class="card-destination" href={ link }>
                    <div class="card-image lozad cover-image bg-dark text-white rounded shadow" style={{ height: 300 }} 
                        data-background-image={ backgroundImage }>
                        <div class="card-body p-4">
                            <h3 class="card-title text-white mb-3">{ title }</h3>
                            <p class="small">
                                { description }
                            </p>
                            <div class="text-warning font-weight-bolder">{ viewMore }</div>
                        </div>
                    </div>
                </a>
            );
        },
    });
}